/* Frame anatomy: links image hotspots and list items so selecting either highlights both */
if (!customElements.get('frame-anatomy')) {
  customElements.define('frame-anatomy', class FrameAnatomy extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-fa-pin]');
        if (trigger && this.contains(trigger)) this.select(trigger.dataset.faPin);
      });
      if (window.matchMedia('(hover: hover)').matches) {
        this.addEventListener('mouseover', (event) => {
          const pin = event.target.closest('.bo-fa__pin');
          if (pin && this.contains(pin)) this.select(pin.dataset.faPin);
        });
      }
      this.select(this.dataset.active || '1');
    }

    select(index) {
      this.dataset.active = index;
      this.querySelectorAll('[data-fa-pin]').forEach((el) => {
        el.setAttribute('aria-pressed', String(el.dataset.faPin === index));
      });
      this.querySelectorAll('[data-fa-item]').forEach((el) => {
        el.classList.toggle('is-active', el.dataset.faItem === index);
      });
    }
  });
}
